import { createSelector } from "reselect";
import { getLocationsList } from "./getLocationsList";

export const getLocationsListContainsParents = createSelector(
    getLocationsList,
    (locations): boolean => !!locations.find((location) => location.locationType === "BRAND")
);
